// Lifecycle of an embedded NetSuite SuiteApp setup job (embedded.netsuite_setup_job).
// Shared by the core API (writer), the public API and the embedded SDK (readers).
export const NETSUITE_SETUP_JOB_STATUS = Object.freeze({
  QUEUED: 'queued',
  INSTALLING: 'installing',
  VERIFYING: 'verifying',
  VERIFIED: 'verified',
  FAILED: 'failed'
});

export const NETSUITE_SETUP_ACTIVE_STATUSES = Object.freeze([NETSUITE_SETUP_JOB_STATUS.QUEUED, NETSUITE_SETUP_JOB_STATUS.INSTALLING, NETSUITE_SETUP_JOB_STATUS.VERIFYING]);

export const NETSUITE_SETUP_ERROR_CODE = Object.freeze({
  DEPLOY_TOKEN_REJECTED: 'deploy_token_rejected',
  DEPLOY_FAILED: 'deploy_failed',
  SCRIPTS_UNREACHABLE: 'scripts_unreachable',
  INTERRUPTED: 'interrupted',
  INTERNAL: 'internal'
});

// Fields the deployer needs on top of the connection itself.
export const NETSUITE_SETUP_REQUIRED_SECRET_KEYS = Object.freeze(['realm', 'deploymentAccessToken', 'deploymentTokenSecret']);

export const isNetsuiteSetupJobActive = (status) => NETSUITE_SETUP_ACTIVE_STATUSES.includes(status);
